import * as actionTypes from '../action-types';
import { WatcherExistsActions } from '../actions';
import { WatcherExistsType } from './watcherExists.types';

export const defaultState: WatcherExistsType = {
  key: '',
  alreadyExists: false,
};

export function watcherExistsReducer(
  state: WatcherExistsType = defaultState,
  action: WatcherExistsActions,
) {
  switch (action.type) {
    case actionTypes.SET_WATCHER_EXISTS: {
      return {
        ...action.payload,
      };
    }
    default: {
      return state;
    }
  }
}
